// Dependencies
import radium from 'radium';
import ZigZagBox from '../../../components/zig-zag-box/ZigZagBox.jsx';
import EventInfos from '../event/EventInfos.jsx';
import TicketsOverview from '../event/tickets-overview/TicketsOverview.jsx';
import ActionBar from '../event/action-bar/ActionBar.jsx';


// Styles
const style = {
	container: {
		margin: '0 0 2em',
	},
};

function ShoppingCart(props) {
	const buildEventUrl = (event) => (event.displayTickets[0].isVisualTicket || event.displayTickets[0].isVisualBulkTicket ?
			`/sp/${event.eventUuid}/seatingplan` :
			`/fs/${event.eventUuid}`);

	return (
		<div style={style.container}>
			<div className="shopping-cart">
				{props.shoppingCartEvents.map((event, index) => (
					<ZigZagBox key={index.toString()}>
						<EventInfos
							title={event.event}
							subtitle={event.eventSubtitle}
							date={event.eventBegin}
							location={`${event.venue}, ${event.locationPostalCode} ${event.locationCity}`}
						/>
						<TicketsOverview tickets={event.displayTickets} />
						<ActionBar eventUrl={buildEventUrl(event)} eventUuid={event.eventUuid} eventTitle={event.event}/>
					</ZigZagBox>
					))
				}
			</div>
		</div>
	);
}


export default radium(ShoppingCart);
